'use client';

import React from 'react';

import { AnimcoBannerType } from '@app-types/animco';

import { PromoBanner } from '@components/promo-banner';

export type AnimcoBannerProps = {
    banner?: AnimcoBannerType | null;
};

export function AnimcoBanner({ banner }: Readonly<AnimcoBannerProps>) {
    if (!banner) return null;

    return (
        <PromoBanner
            text={banner.text}
            sticker={
                banner.hasDisplaySticker
                    ? {
                          value: banner.stickerValue,
                          tooltip: banner.stickerTooltip,
                          color: banner.stickerColor,
                      }
                    : undefined
            }
            isInverted={banner.isInverted}
            linkTracking={banner.tracking}
        />
    );
}
